import { Loader2 } from 'lucide-react'
import { Button } from '../ui/button'
import { useFormContext } from '@/lib/form'
import { cn } from '@/lib/utils'

export function SubmitButton({
  label,
  className,
}: {
  label: string
  className?: string
}) {
  const form = useFormContext()
  return (
    <form.Subscribe
      selector={(state) => ({
        isSubmitting: state.isSubmitting,
        isValid: state.isValid,
        isTouched: state.isTouched,
      })}
    >
      {({ isSubmitting, isValid, isTouched }) => (
        <Button
          className={cn('w-full', className)}
          type="submit"
          disabled={isSubmitting || (isTouched && !isValid)}
        >
          {isSubmitting && <Loader2 className="animate-spin" />}
          {label}
        </Button>
      )}
    </form.Subscribe>
  )
}
